import { Menu, Phone, X } from "lucide-react";
import { useState } from "react";
import { COMPANY, NAV_LINKS } from "../lib/constants";
import { createWhatsAppLink } from "../lib/whatsapp";
import { useScroll } from "../hooks/useScroll";

export function Header() {
  const [open, setOpen] = useState(false);
  const scrolled = useScroll(12);

  return (
    <header className={`home-header ${scrolled ? "home-header-scrolled" : ""}`} data-testid="homepage-header">
      <a href="#inicio" className="relative z-50 flex-shrink-0 group flex items-center">
        {/* Placeholder Invisível (Segura o espaço lateral para o menu não colar) */}
        <div className="logo-placeholder"></div>

        {/* A Imagem do Logo (Posição Absoluta para "vazar" de forma perfeita) */}
        <img src="/img/logo.png" alt="Auto Socorro Pedrinho"
          className="custom-header-logo" />
      </a>
      <nav className={`header-nav ${open ? "is-open" : ""}`} aria-label="Menu principal" data-testid="header-navigation">
        {NAV_LINKS.map((link, index) => (
          <a key={link.label} href={link.href} onClick={() => setOpen(false)} data-testid={`header-nav-link-${index}`}>{link.label}</a>
        ))}
      </nav>
      <div className="header-actions" data-testid="header-actions">
        <a className="phone-pill" href={COMPANY.phoneHref} data-testid="header-phone-link"><Phone size={16} /> {COMPANY.phone}</a>
        <a className="whatsapp-pill" href={createWhatsAppLink()} data-testid="header-whatsapp-link">WhatsApp</a>
      </div>
      <button className="mobile-menu-button" type="button" onClick={() => setOpen(!open)} aria-label={open ? "Fechar menu" : "Abrir menu"} data-testid="mobile-menu-toggle-button">
        {open ? <X size={22} /> : <Menu size={22} />}
      </button>
    </header>
  );
}